import React, { useCallback } from 'react'
import MainIcon from '../../../../../../img/svg/main'
import { PickupMonitorOptionButtonIcon, PickupMonitorOptionButtonText, PickupMonitorOptionButtonWrap } from './index.styled'
import Loader from '../../../../../Elements/loaders'

const PickupMonitorOptionButton = React.memo(({ onClick, icon, text, className, disabled, isOrderStatusUpdating }) => {
	const layout = (disabled ? 'disabled ' : '') + className

	const handleOnClick = useCallback(() => {
		if (disabled) return
		onClick()
	}, [disabled, onClick])

	return (
		<PickupMonitorOptionButtonWrap type="button"
																	 onClick={handleOnClick}
																	 className={layout}
																	 disabled={disabled}>
			{isOrderStatusUpdating ? <Loader zoom={0.5} color="gray" /> : <>
				<PickupMonitorOptionButtonIcon className={layout}>
					<MainIcon icon={icon} />
				</PickupMonitorOptionButtonIcon>
				<PickupMonitorOptionButtonText className={layout}>
					{text}
				</PickupMonitorOptionButtonText>
			</>}
		</PickupMonitorOptionButtonWrap>
	)
})

PickupMonitorOptionButton.displayName = 'PickupMonitorOptionButton'
export default PickupMonitorOptionButton
